



















































import { Site } from "@/shared/Site";
import { Enseigne } from "@/shared/Enseigne";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import { Prop, Component } from "vue-property-decorator";
import _ from "lodash";
import ListeGroupes from "@/components/listeGroupes.vue";

@Component({
  components: { ListeGroupes },
})
export default class ListSitesExport extends mixins(MobileMixin) {
  public renderSites: any;
  public group: string = "TOUS";
  public searchTxt: string = "";
  public restaurantIds_to_enseigne: any = {};
  public restaurantIds: any = [];
  public siteNames: any = {};
  @Prop(Function) public readonly onSelectSite!: (site: any) => void;

  public async init(realInit: boolean = true) {
    this.restaurantIds = [];
    this.sites.forEach(async (site: any) => {
      if (!this.restaurantIds.includes(site.restaurantId)) {
        this.restaurantIds.push(site.restaurantId);
        this.siteNames[site.restaurantId] = site.libelle;
      }
    });
    this.renderSites = this.sites.filter(
      (site: any) =>
        site.groupe[0] === this.group ||
        site.groupe.length === 0 ||
        this.group === "TOUS"
    );
  }

  public created() {
    const enseignes = this.enseignes;
    enseignes.forEach((enseigne: Enseigne) => {
      this.restaurantIds_to_enseigne[enseigne.restaurantId] = enseigne.libelle;
    });
  }

  public handleSelect(site: any) {
    this.onSelectSite(site);
    this.searchTxt = "";
  }
  public onSearchFieldClicked(event: MouseEvent): void {
    event.stopPropagation();
  }

  public changeGroup(gr: any) {
    this.group = gr;
    if (gr) {
      if (gr !== "TOUS") {
        this.renderSites = this.sites.filter((site: any) => {
          return site.groupe.indexOf(gr) !== -1;
        });
      } else {
        this.renderSites = this.sites;
      }
    }
    if (this.searchTxt.trim() !== "") {
      this.renderSites = this.renderSites.filter((site: any) => {
        return (
          site.libelle.includes(this.searchTxt.toUpperCase()) ||
          site.restaurantId.toString().includes(this.searchTxt)
        );
      });
    }
    this.renderSites = _.orderBy(this.renderSites, "status");
  }

  get sites(): Site[] {
    const sites = this.$store.getters["login/sites"];
    sites.sort((u1: Site, u2: Site) => {
      return u1.restaurantId < u2.restaurantId;
    });
    return sites;
  }

  get enseignes(): any {
    return this.$store.getters["login/enseignes"];
  }
}
